import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { datetimeFormat } from 'app/constants/date-time-format';
import { DataService, DateService } from 'app/services';

@Component({
  selector: 'app-ro-activities',
  templateUrl: './ro-activities.component.html',
  styleUrls: ['./ro-activities.component.scss'],
})
export class RoActivitiesComponent implements OnInit {
  @Input('activities')
  set activities(activities: any[]) {
    const groupedActivities = {};
    this._activities = [];

    activities.forEach((activity) => {
      const key = this.dateService.formatDate(new Date(activity.createdAt), datetimeFormat.mmmdyyyy);

      if (groupedActivities[key] && groupedActivities[key].length) {
        groupedActivities[key].push(activity);
      } else {
        groupedActivities[key] = [activity];
      }
    });

    Object.keys(groupedActivities).forEach((key) => {
      this._activities.push({
        date: key,
        activities: groupedActivities[key],
      });
    });
  }
  @Input('selectedTab')
  set selectedTab(selectedTab: number) {
    if (selectedTab === 2) {
      this.searchActivities.emit({ search: '', iShowAllActivities: false });
    }
  }
  @Input() code: string = '';
  @Input() invCode: string = '';

  @Output() openAttachmentTab: EventEmitter<any> = new EventEmitter();
  @Output() searchActivities: EventEmitter<any> = new EventEmitter();

  _activities: any[] = [];

  constructor(private dataService: DataService, private dateService: DateService) {}

  ngOnInit() {}

  openCustomerInSidepanel({ customerId }) {
    this.dataService.sendData(this.dataService.typeSidebar('customer', customerId, '', {}));
  }

  handleOpenAttachmentTab(attachmentId) {
    this.openAttachmentTab.emit(attachmentId);
  }

  openVehicleInSidepanel({ customerId, vehicleId }) {
    this.dataService.sendData(
      this.dataService.typeSidebar('vehicle', customerId, '', {
        vehicleId,
        _id: customerId,
      })
    );
  }
}
